import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import StartForm from "../components/StartForm";
import { setCookie, check } from "../modules/auth";

const StartContainer = ({ history, hp_token }) => {
  const [buttonClicked, setButtonClicked] = useState(false);
  const [progress, setProgress] = useState(0);
  const dispatch = useDispatch();
  const { cookie, cookieError, auth, authError } = useSelector(({ auth }) => ({
    cookie: auth.cookie,
    cookieError: auth.cookieError,
    auth: auth.auth,
    authError: auth.authError,
  }));

  /*
   * start page 접근시 로그인 정보 확인
   * 만약 토큰이 쿠키에 있다면 바로 쿠키의 유효성을 확인하는 check() 메소드 수행
   *
   * 토큰이 쿠키에 없을 때
   *   if 학습기라면
   *     초등 / 중등 앱 여부(isSchoolingUser = false / true)와 기존에 통신한 토큰 내용(diag_token, 진단검사 POST /user API에서 보냄)을 window.Android.getInitVariables() 객체에서 확인
   *   elif 홈페이지라면
   *     진단검사 POST /user API에서 보낸 token을 start page URL의 파라미터로 받아서 확인
   *     start page의 URL에 token 정보가 있으므로 start page의 기본 링크로 redirect
   *
   * setCookie()는 클라이언트의 쿠키스토어가 여러개여서 발생하는 문제이므로
   * 현재 리액트 프론트가 동작하는 클라이언트에 강제로 쿠키를 넣는 메소드임
   */
  useEffect(() => {
    if (window.Android) {
      const token = JSON.parse(window.Android.getInitVariables())["diag_token"];
      const is_middle = JSON.parse(window.Android.getInitVariables())[
        "isSchoolingUser"
      ];
      dispatch(setCookie({ token, is_middle }));
    } else if (hp_token) {
      dispatch(setCookie({ token: hp_token, is_middle: null }));
      history.push("/diagnosis");
    } else {
      dispatch(check());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, hp_token]);

  /*
   * setCookie() 메소드를 통해 강제로 쿠키를 저장했다면
   * 쿠키의 유효성 여부를 check() 메소드를 통해 확인해준다.
   */
  useEffect(() => {
    if (cookie) {
      dispatch(check());
    } else if (cookieError) {
      console.log("오류 발생");
      console.log(cookieError);
      return;
    }
  }, [cookie, cookieError, dispatch]);

  /*
   * 쿠키가 유효하면 쿠키를 해독해 접속 정보를 auth라는 객체로 응답받을 수 있다.
   * auth 객체가 존재한다면 쿠키가 유효하다는 뜻이므로 진단검사 시작 페이지를 보여준다.
   * 미리 정의된 페이드인 효과를 content의 main 영역의 class에 scene-in을 추가해 사용할 수 있다.
   */
  useEffect(() => {
    if (authError) {
      console.log("오류 발생");
      console.log(authError);
      return;
    } else if (auth) {
      document
        .getElementsByClassName("math-AI-scanning")[0]
        .classList.add("scene-in");
    }
  }, [auth, authError, dispatch]);

  /*
   * start page의 시작 버튼을 클릭하는 이벤트를 다루는 메소드
   * buttonClicked state를 통해 더블클릭을 방지.
   * 버튼을 클릭하면 progress 바의 수치를 1초 뒤에 100으로 바꾼다.
   * progress의 수치가 바뀌면 시작버튼이 프로그레스 바로 바뀌고
   * 프로그레스바가 css 효과로 몇초간 차오르는 것처럼 보인다 (로딩 효과)
   * 이후 tutorial page로 이동
   */
  const onClick = () => {
    if (!buttonClicked) {
      setButtonClicked(true);
      setTimeout(setProgress, 1000, 100);
      document
        .getElementsByClassName("math-AI-scanning")[0]
        .classList.remove("scene-in");
      setTimeout(() => {
        document
          .getElementsByClassName("math-AI-scanning")[0]
          .classList.add("scene-out");
      }, 2000);
      setTimeout(() => {
        history.push("/diagnosis/tutorial");
      }, 2500);
    }
  };
  return (
    <>
      {auth ? (
        <StartForm
          onClick={onClick}
          buttonClicked={buttonClicked}
          progress={progress}
          t_type={auth.t_type}
        ></StartForm>
      ) : (
        <p>no</p>
      )}
    </>
  );
};

export default withRouter(StartContainer);
